import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  personaPercentage: []
}

const personaQuerySlice = createSlice({
  name: 'personaQuery',
  initialState,
  reducers: {
    setPersonaPercentage: (state, action) => {
      state.personaPercentage = action.payload
    }
  }
})

export const {setPersonaPercentage} = personaQuerySlice.actions

// Selectors with null-safe defaults
export const selectPersonaPercentage = (state) => state.personaQuery?.personaPercentage ?? []

export default personaQuerySlice.reducer
